import { useState, useEffect } from 'react';
import { gateQueueAPI } from '../services/api';

// The flight currently at a gate (its running session, else the next one due) —
// used to pre-fill template placeholders like {FlightNumber} and {Gate} when a
// request is made for that gate, so nobody re-types what the system knows.
// Works for every role: operators get their own gate, supervisors/managers the
// gate they picked. Returns { gate, session } (either may be null).
export function useGateFlightContext(gateId, sessionId) {
  const [ctx, setCtx] = useState({ gate: null, session: null });

  useEffect(() => {
    if (!gateId) { setCtx({ gate: null, session: null }); return; }
    let cancelled = false;
    gateQueueAPI.getQueue(gateId, sessionId, { skipErrorToast: true })
      .then(res => { if (!cancelled) setCtx({ gate: res.data.data?.gate || null, session: res.data.data?.session || null }); })
      .catch(() => { if (!cancelled) setCtx({ gate: null, session: null }); });
    return () => { cancelled = true; };
  }, [gateId, sessionId]);

  return ctx;
}
